import { TOKEN_TABLEAU } from '../actions/types';

import { INITIAL_STATE } from '../states/states';

export default (state = INITIAL_STATE.TABLEAU, action) => {
  // debugger;
  switch (action.type) {
    case TOKEN_TABLEAU:
      return { tableau: action.payload }
    default:
      return state;
  }
};
